module.exports = __webpack_public_path__ + "static/media/item1.c7060ab5.png";